import { render } from "./NexusRegistration.vue?vue&type=template&id=7a4b2c5a&scoped=true"
import script from "./NexusRegistration.vue?vue&type=script&lang=js"
export * from "./NexusRegistration.vue?vue&type=script&lang=js"

import "./NexusRegistration.vue?vue&type=style&index=0&id=7a4b2c5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4b2c5a"]])

export default __exports__